<template>
    <div :id="`page-${data?.id}`" class="elle-page-content elle-single">
        <section class="elle-page-content-wrapper padd-v">
            <div class="container">
                <div class="grid12">
                    <div class="l-col">
                        <div class="page-media">
                            <UiImage :src="data.media[0]?.webp" />
                        </div>
                    </div>
                    <div class="m-col">
                        <UiHeadline
                            :settings="{
                                label: data?.label,
                                headline: data?.headline
                            }"
                        />
                    </div>
                    <div v-if="!!data?.content.length" class="r-col">
                        <CommonContent :data="data?.content" />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup lang="ts">
defineProps({
    data: {
        type: Object,
        default: () => ({})
    }
});
</script>
